import { useContext } from 'react';
import { I18nContext } from './i18nContext';

export default function useTranslation() {
  const context = useContext(I18nContext);
  if (!context) {
    return {
      t: (key) => key,
      language: 'en',
      setLanguage: () => {},
      supportedLanguages: ['en', 'fr'],
    };
  }
  return context;
}
